export default "__VITE_ASSET__Bv60jfMk__"